export const PENDING = Symbol("pending");
export const FULFILLED = Symbol("fulfilled");
export const REJECTED = Symbol("rejected");
export var DeferredState = /* @__PURE__ */ ((DeferredState2) => {
  DeferredState2[DeferredState2["PENDING"] = 0] = "PENDING";
  DeferredState2[DeferredState2["FULFILLED"] = 1] = "FULFILLED";
  DeferredState2[DeferredState2["REJECTED"] = 2] = "REJECTED";
  return DeferredState2;
})(DeferredState || {});
export default class Deferred {
  promise;
  resolve = () => {
  };
  reject = () => {
  };
  state;
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
      this.state = 0 /* PENDING */;
    }).then((e) => {
      this.state = 1 /* FULFILLED */;
      return e;
    }).catch((e) => {
      this.state = 2 /* REJECTED */;
      throw new Error(e);
    });
  }
  static create() {
    return new Deferred();
  }
}
